import React from 'react';

const LegalConsultationIcon = () => {
  return (
    <>
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.9341 11.0949V1.57841C19.2626 2.08189 20.4849 2.85747 21.521 3.89206L26.5906 8.96461C27.6267 9.99921 28.4023 11.2215 28.9057 12.55H19.3892C18.586 12.55 17.9341 11.8967 17.9341 11.0949ZM34.9692 33.3481C35.5382 33.917 35.5382 34.8367 34.9692 35.4056C34.6855 35.6894 34.313 35.832 33.9405 35.832C33.568 35.832 33.1954 35.6894 32.9117 35.4056L27.1538 29.6477L24.8459 31.9555L25.1472 32.2568C25.7161 32.8257 25.7161 33.7453 25.1472 34.3143C24.8634 34.598 24.4909 34.7407 24.1184 34.7407C23.7459 34.7407 23.3734 34.598 23.0896 34.3143L16.5416 27.7663C15.9726 27.1973 15.9726 26.2777 16.5416 25.7087C17.1105 25.1398 18.0302 25.1398 18.5991 25.7087L18.6806 25.7902L25.3538 19.117L25.2723 19.0355C24.7033 18.4666 24.7033 17.5469 25.2723 16.978C25.8413 16.409 26.7609 16.409 27.3298 16.978L33.8779 23.526C34.4468 24.095 34.4468 25.0146 33.8779 25.5836C33.5941 25.8673 33.2216 26.0099 32.8491 26.0099C32.4766 26.0099 32.1041 25.8673 31.8203 25.5836L31.5191 25.2824L29.2113 27.5902L34.9692 33.3481ZM14.484 29.8238C12.7815 28.1228 12.7815 25.3522 14.484 23.6512C15.4022 22.7315 16.6784 22.2659 17.9647 22.3896L21.9532 18.4011C21.9415 18.2701 21.9357 18.1392 21.9357 18.0067C21.9357 17.0769 22.2355 16.198 22.7709 15.4603H19.3892C16.9825 15.4603 15.0239 13.5017 15.0239 11.0949V0.943981C14.7896 0.927974 14.5553 0.909058 14.3181 0.909058H7.74827C3.7365 0.909058 0.472656 4.1729 0.472656 8.18467V28.5564C0.472656 32.5682 3.7365 35.832 7.74827 35.832H20.4922L14.484 29.8238Z"
          fill="#9A252D"
        />
      </svg>
    </>
  );
};

export default LegalConsultationIcon;
